import { render, staticRenderFns } from "./DonutChart56.vue?vue&type=template&id=22345ea4&scoped=true"
import script from "./DonutChart56.vue?vue&type=script&lang=js"
export * from "./DonutChart56.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22345ea4",
  null
  
)

export default component.exports